const staticCache: {[name: string]: {promise: Promise<unknown>; timestamp: number}} = {}
const CLEAR_AFTER_MILLIS = 10 * 60 * 1000 // clear items after being in cache for this long
const INTERVAL_TIME = 2 * 60 * 1000 // check this often
let cacheClearInterval
const ACCEPTED_PATHS = ['/d/review/summary']


function startTimer() {
  if (!cacheClearInterval) {
    cacheClearInterval = setInterval(() => {
      const cachedKeys = Object.keys(staticCache)
      if (cachedKeys.length === 0) {
        clearInterval(cacheClearInterval)
        cacheClearInterval = undefined
        return
      }
      const ts = new Date().getTime()
      cachedKeys.forEach((key) => {
        if (ts - staticCache[key].timestamp >= CLEAR_AFTER_MILLIS) {
          delete staticCache[key]
        }
      })
    }, INTERVAL_TIME)
  }
}

export function getCachedPath(path: string): {promise: Promise<unknown>; timestamp: number} {
  return staticCache[path]
}

export function cachePath(path: string, promise: Promise<unknown>): void {
  if (ACCEPTED_PATHS.find(ap => path.indexOf(ap) > -1)) {
    staticCache[path] = { promise, timestamp: new Date().getTime() }
    startTimer()
  }
}
